import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { id, status } = payload || {}
    const endpoint = (status === 'active') 
      ? ADMIN_ENDPOINTS.ADMIN_DEALS_ACTIVATE 
      : ADMIN_ENDPOINTS.ADMIN_DEALS_DEACTIVATE

    return buildApiUrl(endpoint, {
      pathParams: {
        id,
      },
    })
  },

  method: 'POST',

  format(payload) {
    // Endpoints for activate/deactivate don't strictly need a body according to common patterns,
    // but returning an empty object is fine.
    return {}
  },

  parse(raw = {}) {
    if (raw.statusCode !== 200 && raw.statusCode !== 201) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to update promotion status',
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Statut de la promotion mis à jour',
      data: raw.data,
    }
  },
}
